import React from 'react';
import ReactJson from 'react-json-view'

export default (props) => {
    return (<ReactJson src={props.json} theme="monokai" />)
}
